export enum EnumSubscriberStatus {
  TRIAL = 'TRIAL',
  PAID = 'PAID',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
}